import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppContentsService } from '../../../services/app-contents.service';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { ManuscriptList } from '../../../models/manuscript';
import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-page-home',
  templateUrl: './page-home.component.html',
  styleUrls: ['./page-home.component.css']
})
export class PageHomeComponent implements OnInit, OnDestroy {
    msTitle: SafeHtml;
    msDescription: SafeHtml;
    edTitle: SafeHtml;
    edDescription: SafeHtml;
    private mssList: ManuscriptList;
    private subscriptions: Array<ISubscription> = [];

    constructor(
        private sanitizer: DomSanitizer,
        private appContentsService: AppContentsService,
        private manuscriptsService: ManuscriptsService
    ) {
    }

    ngOnInit(): void {
        this.msTitle = globals.html_small_loading_gif;
        this.msDescription = globals.html_small_loading_gif;
        this.edTitle = globals.html_small_loading_gif;
        this.edDescription = globals.html_small_loading_gif;

        /* Page contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('home')
                .subscribe(
                    page => {
                        if (page && page.name === 'home') {
                            const msContents = page.contents.find(c => c.name === 'manuscripts');
                            if (msContents) {
                                this.msTitle = this.sanitizer.bypassSecurityTrustHtml(msContents.title);
                                this.msDescription = this.sanitizer.bypassSecurityTrustHtml(msContents.text);
                            }
                            const edContents = page.contents.find(c => c.name === 'edition');
                            if (edContents) {
                                this.edTitle = this.sanitizer.bypassSecurityTrustHtml(edContents.title);
                                this.edDescription = this.sanitizer.bypassSecurityTrustHtml(edContents.text);
                            }
                        }
                    },
                    err => console.error(err)
                )
        );

        /* Reset filters without reloading manuscript list */
        this.manuscriptsService.resetFilters(false);

        /* Preloading the manuscript list for the subcomponents */
        this.subscriptions.push(
            this.manuscriptsService.getManuscripts()
                .subscribe(response => this.mssList = response, err => console.error(err))
        );
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-home/page-home.component.ts